export default __webpack_public_path__ + "static/7-microchip-42624116a8dac2ffb009be5537eee160.png";